<template>
<div>
    <h3 class="font-weight-regular mb-3 submenu-title">{{$t('zargeBandseite')}}</h3>
    <!-- E komentuar pasi qe nuk ka pasur nevoje per dependency sepse description eshte dashur te jete e nejejt -->
    <!-- <div class="body-2 lighter-text">{{ getRegisteredCharacteristicsValue("CUST_MM_ZARGE_ART", frameContext).value.description }} -->
    <div class="body-2 violet-text">{{ getRegisteredCharacteristicsValue("KTU_MM_ZARGEN_KURZFORM", frameContext).value.description }}
    </div>
    <v-row>
            <v-col cols="6">
                <div class="subtitle-2 mb-2">{{$t('zargenOberflache')}}</div>
                <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="frameSurfaceCharacteristicsDropdown" item-text="description"
                    :value="getRegisteredCharacteristicsValue('CUST_MM_ZARGE_OBERFL_BS_N', doorLeafSurfaceContext).value"
                    @change="handleFrameSurfaceOptionSelect($event);">
                </v-select>

                <div class="body-2 pb-2" style="">
                    {{$t('sonderlackierung')}}</div>
                <v-text-field  v-model="specialDecor"  :disabled="!frameInputEnabled" dense outlined hide-details >
                </v-text-field>
               
            </v-col>
            <v-col cols="6">
                <div class="subtitle-2 mb-2">{{$t('aufsteckhulsenBander')}}</div>
                <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="coverCapsCharacteristicDropdown" item-text="description"
                    :value="getRegisteredCharacteristicsValue('CUST_MM_AUFSTECKHUELSEN', doorLeafSurfaceContext).value"
                    @change="handleCoverCapesOptionSelect($event)">
                </v-select>
               
            </v-col>
        </v-row>
</div>
    <!-- <div>
        <h1 class="title">Zarge Bandseite</h1>
        <label class="input-label">{{ getRegisteredCharacteristicsValue("CUST_MM_ZARGE_ART", doorLeafSurfaceContext).value.description }}</label>
        <div class="zarge-wrap">
            <label class="input-label">Zargen Oberfläche</label>
                <div class="full-dropdown">
                    <div class="dropdown">
                           <button class="btn btn-secondary dropdown-toggle dropdown-button"
                                type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue("KTU_MM_ZARGE_OBERFL_BS", doorLeafSurfaceContext).value.description }}<span></span>
                            </button>
                            <div class="dropdown-menu open-top" aria-labelledby="dropdownMenuButton">
                                <div class="simplebar" data-simplebar>
                                    <div>
                                        <a v-for="(valueDefinition, index) in frameSurfaceCharacteristicsDropdown" :key="index"
                                        @click.prevent="handleFrameSurfaceOptionSelect(valueDefinition);" 
                                        class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                                    </div> 
                                </div>
                            </div>
                    </div>
                </div>
                
                <div :class="{'input-group' : true, 'disabled' : !frameInputEnabled}">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing-default">Sonderlackierung / RAL Farbe / angeben  </span>
                    </div>
                    <input type="text" class="form-control" v-model="specialDecor" aria-label="Default" :disabled="!frameInputEnabled"
                        aria-describedby="inputGroup-sizing-default" value="">
                </div>    
                
                <label class="input-label">Aufsteckhulsen fur Bander</label>
                <div class="full-dropdown">
                    <div class="dropdown">
                           <button class="btn btn-secondary dropdown-toggle dropdown-button"
                                type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue("CUST_MM_AUFSTECKHUELSEN", doorLeafSurfaceContext).value.description }}<span></span>
                            </button>
                            <div class="dropdown-menu open-top" aria-labelledby="dropdownMenuButton">
                                <div class="simplebar" data-simplebar>
                                    <div>
                                        <a v-for="(valueDefinition, index) in coverCapsCharacteristicDropdown" :key="index"
                                        @click.prevent="handleCoverCapesOptionSelect(valueDefinition);" 
                                        class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                                    </div> 
                                </div>
                            </div>
                    </div>
                </div>
        </div>
    </div> -->
</template>
<script>
import Vue from 'vue';  
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';       
import { DoorConfiguration } from '../../../configurator/DoorConfiguration';
  
 export default Vue.extend({
    name: 'FrameSurfaceOpeningSide',        
    props: {
        characteristic: Object,            
    },
    data() {
        return {
            doorLeafSurfaceContext : DoorConfiguration.DoorLeafSurface,
            frameContext : DoorConfiguration.Frame,
            frameSurfaceCharacteristicsDropdown : [],
            coverCapsCharacteristicDropdown : [],
            frameInputEnabled : false,
            specialDecorValue : '',
        }
    },
    computed: {            
           ...mapGetters('configuratorModule',['getCurrentDoorConfiguration','getRegisteredCharacteristicsValue','getBlankCharacteristic']),
           ...mapGetters('doorLeafSurfaceModule', [ 'getCharacteristicAndValues', 'getNrOfValuesByCharacteristic', 'checkRadioValue' ]),
            specialDecor : {
                 //getter
                get: function ()  {
                    if(parseInt(this.getRegisteredCharacteristicsValue('KTU_MM_ZARGE_OBERFL_SOND_BS', this.doorLeafSurfaceContext).value.value) == 0)
                    {
                        this.specialDecorValue = '';
                    }else {
                        this.specialDecorValue = this.getRegisteredCharacteristicsValue('KTU_MM_ZARGE_OBERFL_SOND_BS', this.doorLeafSurfaceContext).value.value
                    }
                     
                    return this.specialDecorValue;
                },
                //setter
                set : function(newValue )  {
                    this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_ZARGE_OBERFL_SOND_BS'), value: newValue });
                    this.specialDecorValue = newValue;
                }
            },
        },
        methods: {
            ...mapActions('configuratorModule',['updateDoorConfiguration']),
            ...mapActions('doorLeafSurfaceModule', ['addCharacterisitc','valueAddCharacteristic', 'calculateDoorLeafSurfaceZargeBS']),
            handleFrameSurfaceOptionSelect(valueDefinition) {
                this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("CUST_MM_ZARGE_OBERFL_BS_N"), valueDefinition: valueDefinition });
                this.calculateDoorLeafSurfaceZargeBS();
                if(valueDefinition.value === '12') {
                    this.frameInputEnabled = true;
                }else {
                    this.specialDecor = '';
                    this.frameInputEnabled = false;
                }
                
            },
            handleCoverCapesOptionSelect(valueDefinition) {
                this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("CUST_MM_AUFSTECKHUELSEN"), valueDefinition: valueDefinition });
                this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_AUFSTECKHUELSEN");
                
            }
        },
        mounted() {
            this.frameSurfaceCharacteristicsDropdown = this.getCharacteristicAndValues("CUST_MM_ZARGE_OBERFL_BS_N", this.doorLeafSurfaceContext).values;
            this.coverCapsCharacteristicDropdown = this.getCharacteristicAndValues("CUST_MM_AUFSTECKHUELSEN", this.doorLeafSurfaceContext).values;
            this.handleFrameSurfaceOptionSelect(this.getRegisteredCharacteristicsValue('CUST_MM_ZARGE_OBERFL_BS_N', this.doorLeafSurfaceContext).value);
        }
 });
</script>
<style scoped>

</style>